import { BOARD_SIZE, SHIP_LENGTHS } from '../constants';
import type { ICell, TShip } from '../types';

function createEmptyGrid(): boolean[][] {
  return Array.from({ length: BOARD_SIZE }, () =>
    Array.from({ length: BOARD_SIZE }, () => false),
  );
}

function markOccupiedAndAdjacent(grid: boolean[][], cells: ICell[]): void {
  const dirs = [
    [-1, -1],
    [-1, 0],
    [-1, 1],
    [0, -1],
    [0, 0],
    [0, 1],
    [1, -1],
    [1, 0],
    [1, 1],
  ];
  for (const { col, row } of cells) {
    for (const [dr, dc] of dirs) {
      const r = row + dr;
      const c = col + dc;
      if (r >= 0 && r < BOARD_SIZE && c >= 0 && c < BOARD_SIZE) {
        grid[r][c] = true;
      }
    }
  }
}

function canPlace(
  grid: boolean[][],
  length: number,
  row: number,
  col: number,
  horizontal: boolean,
): boolean {
  if (horizontal) {
    if (col + length > BOARD_SIZE) return false;
    for (let c = col; c < col + length; c++) {
      if (grid[row][c]) return false;
    }
  } else {
    if (row + length > BOARD_SIZE) return false;
    for (let r = row; r < row + length; r++) {
      if (grid[r][col]) return false;
    }
  }
  return true;
}

function placeShip(grid: boolean[][], length: number): TShip | null {
  const maxAttempts = 200;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const horizontal = Math.random() < 0.5;
    const row = horizontal
      ? Math.floor(Math.random() * BOARD_SIZE)
      : Math.floor(Math.random() * (BOARD_SIZE - length + 1));
    const col = horizontal
      ? Math.floor(Math.random() * (BOARD_SIZE - length + 1))
      : Math.floor(Math.random() * BOARD_SIZE);
    if (!canPlace(grid, length, row, col, horizontal)) continue;
    const cells: ICell[] = [];
    if (horizontal) {
      for (let c = col; c < col + length; c++) cells.push({ row, col: c });
    } else {
      for (let r = row; r < row + length; r++) cells.push({ row: r, col });
    }
    markOccupiedAndAdjacent(grid, cells);
    return cells;
  }
  return null;
}

export function placeShipsRandom(): TShip[] {
  const grid = createEmptyGrid();
  const ships: TShip[] = [];
  for (const len of SHIP_LENGTHS) {
    const ship = placeShip(grid, len);
    if (!ship) {
      return placeShipsRandom();
    }
    ships.push(ship);
  }
  return ships;
}
